import { Link } from "react-router-dom";
import { Repeat } from "lucide-react";
import { fmtDate } from "@/lib/constants";

export const RecurringAlert = ({ items, testid = "recurring-alert" }) => {
  if (!items?.length) return null;
  return (
    <section data-testid={testid} className="rounded-2xl border-2 border-red-500/70 bg-red-500/10 p-4">
      <div className="flex items-center gap-2 text-sm font-extrabold text-red-300">
        <Repeat className="h-4 w-4" /> Recurring faults: {items.length} problem{items.length > 1 ? "s" : ""} failed twice or more in 12 months
      </div>
      <div className="mt-3 grid gap-2 sm:grid-cols-2">
        {items.map((r) => (
          <Link key={`${r.bike_id}-${r.item_label}`} to={`/fleet/bikes/${r.bike_id}`} data-testid={`recurring-${r.bike_id}-${r.item_label.replace(/\W+/g, "-").toLowerCase()}`}
            className="flex items-center justify-between gap-3 rounded-xl border border-red-500/30 bg-background/50 px-3 py-2 text-sm hover:bg-red-500/10">
            <div className="min-w-0">
              <div className="truncate font-semibold">{r.bike_name} · {r.item_label}</div>
              <div className="text-[11px] text-muted-foreground">Last {fmtDate(r.last_at)}{r.open ? ` · ${r.open} still open` : ""}</div>
            </div>
            <span className="shrink-0 rounded-full bg-red-600 px-2.5 py-0.5 text-xs font-bold text-white">× {r.count}</span>
          </Link>
        ))}
      </div>
    </section>
  );
};
